import React, { Component } from 'react';

export default function withBackButtonHandled(WrappedComponent, onBackButtonPressed) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.onDeviceBackButtonPressed = this.onDeviceBackButtonPressed.bind(this);
    }

    render() {
      return (
        <WrappedComponent onBackButtonPressed={this.onDeviceBackButtonPressed} {...this.props} />
      );
    }

    onDeviceBackButtonPressed() {
      onBackButtonPressed(this.props);
    }
  };
}
